import { ecoVistaLandFillData } from "constants-lib/seo/ecoVistaLandFillData"
import { addJSONLDToHead, removeElement } from "./jsonLD.js"

const getEcoVistaLandFill = () => {
  const data = ecoVistaLandFillData.map((item) => ({
    "@type": `Question`,
    name: item.Question,
    acceptedAnswer: {
      "@type": `Answer`,
      text: item.Answer,
    },
  }))
  return data
}

/* Add FAQ Baster JSON LD if needed, otherwise make sure it does not exist in Head. */
export const addEcoVistaLandFillJSONLD = () => {
  if (
    window.location.href.includes(`/us/en/grand-central-landfill/faq`) &&
    document.getElementById(`ecoVistaLandFillJSONLD`) === null
  ) {
    const script = ecoVistaLandFillJSONLD()
    addJSONLDToHead(script, `ecoVistaLandFillJSONLD`)
  } else {
    removeElement(`ecoVistaLandFillJSONLD`)
  }
}

// JSON LD template for FAQ Bagster
const ecoVistaLandFillJSONLD = () => {
  const FaqBagsterTemplate = {
    "@context": `http://schema.org`,
    "@type": `FAQPage`,
    mainEntity: getEcoVistaLandFill(),
  }
  return FaqBagsterTemplate
}
